import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import ImageNull from 'assets/images/Dashboard/image-null.svg';
import Shimmer from 'components/commom/Shimmer';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import moment from 'moment';
import Loader from 'components/commom/Loader';
import { getScannedMaskCallAPI } from 'store/getScannedMask/action';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';
import CommonToast from 'components/commom/CommonToast';
import CommonModal from 'components/commom/Modal';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ScanResult = ({ enterprise = false }) => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const userRole = getUserRole();
  const [loading, setLoading] = useState(true);
  const [isModalActive, setIsModalActive] = useState(false);
  const [viewData, setViewData] = useState({});

  const scanResult = useSelector(
    (state) => state?.basicDetailsValueReducer?.scanResult
  );
  const scanDetail = useSelector(
    (state) => state?.basicDetailsValueReducer?.scanDetails
  );

  const scannedMaskData = useSelector(
    (state) => state?.getScannedMaskReducer?.users
  );

  useEffect(() => {
    if (scanResult?.image_id) {
      setLoading(true);
      getScannedDetail();
    }
  }, [scanResult]);

  const getScannedDetail = () => {
    const data = `${scanResult?.image_id}/?api_version=v5&mask_over_image=1&haut_response=1&user_id=${scanDetail?.id}`;
    const external = {
      run: true,
      handleFunction: (res) => {
        setLoading(false);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };

    dispatch(getScannedMaskCallAPI(data, external));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          {userRole === 'enterprise-admin' ? (
            <div className="flex pb-16">
              <div className="fs-12 lh-24 family_outfit_regular_400">
                Staff Members
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Staff Details
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Scan Details
              </div>
            </div>
          ) : enterprise ? (
            <div className="flex pb-16">
              <div className="fs-12 lh-24 family_outfit_regular_400">
                Enterprise
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Enterprise Details
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Staff Details
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                User Details
              </div>
            </div>
          ) : (
            <div className="flex pb-16">
              <div className="fs-12 lh-24 family_outfit_regular_400">
                Skin Analyser
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Skin Analyser Details
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Scan Details
              </div>
            </div>
          )}
          <Row className="bg-light-100 m-0 p-24">
            <Col sm={12} className="p-0">
              <div className="flex">
                <div>
                  <Image
                    src={ArrowDetail}
                    alt="icon"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                  Face Skin Metrix Result
                </div>
              </div>
              <Row className="m-0 p-0">
                <Col md={2} className="p-0">
                  <div className="flex align-items-center pt-16">
                    <div className="uploadPhoto">
                      {loading ? (
                        <Shimmer
                          width="100px"
                          height="100px"
                          borderRadius="50%"
                        />
                      ) : (
                        <Image
                          src={
                            scanResult?.original_image !== ''
                              ? scanResult?.original_image
                              : ImageNull
                          }
                          alt="Uploaded profile"
                          className={
                            scanResult?.original_image ? 'uploadPhoto' : ''
                          }
                        />
                      )}
                    </div>
                  </div>
                </Col>
                <Col md={10} className="p-0">
                  <Row className="p-0 m-0">
                    <Col md={6} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Image ID
                      </div>
                      {loading ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                          {scanResult?.image_id}
                        </div>
                      )}
                    </Col>
                    <Col md={6} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Date of Scan
                      </div>
                      {loading ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                          {moment(scanResult?.scanning_date).format(
                            'DD MMM YYYY'
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          {loading ? (
            <Loader marginTop={'20vh'} />
          ) : scannedMaskData &&
            scannedMaskData?.data?.results &&
            scannedMaskData?.data?.results?.length > 0 ? (
            <div className="pt-20 mb-[50px]">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-[20px]">
                {scannedMaskData?.data?.results
                  ?.slice()
                  .filter((item) => !item?.masked_image_url)
                  .map((item, index) => (
                    <div
                      className="bg-white rounded-[20px] overflow-hidden p-[20px] shadow-md"
                      key={index}
                    >
                      <div className="flex justify-between items-center gap-[20px]">
                        <p className="p-0 m-0 fs-16 fc-202224 family_outfit_semiBold_600 lh-176 capitalize">
                          {item?.main_metric?.name}
                        </p>
                        {item?.main_metric?.widget_type === 'bad_good_line' && (
                          <p
                            className={`p-0 m-0 fs-16 fc-202224 family_outfit_semiBold_600 lh-176 capitalize ${
                              item?.main_metric?.value >= 0 &&
                              item?.main_metric?.value < 49
                                ? 'text-[red]'
                                : item?.main_metric?.value >= 50 &&
                                    item?.main_metric?.value < 69
                                  ? 'text-[orange]'
                                  : item?.main_metric?.value >= 70 &&
                                      item?.main_metric?.value <= 89
                                    ? 'text-[green]'
                                    : 'text-[blue]'
                            }`}
                          >
                            {item?.main_metric?.value >= 0 &&
                            item?.main_metric?.value < 49
                              ? 'Bad'
                              : item?.main_metric?.value >= 50 &&
                                  item?.main_metric?.value < 69
                                ? 'Average'
                                : item?.main_metric?.value >= 70 &&
                                    item?.main_metric?.value <= 89
                                  ? 'Good'
                                  : 'Excellent'}
                          </p>
                        )}
                      </div>
                      <div className="mt-[10px]">
                        <p className="p-0 m-0 fs-16 fc-202224 family_outfit_semiBold_600 lh-176 capitalize">
                          {`${item?.main_metric?.value}${item?.main_metric?.widget_type === 'percentage' ? '%' : ''}`}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-[20px] mt-[20px]">
                {scannedMaskData?.data?.results
                  ?.slice()
                  .filter((item) => item?.masked_image_url)
                  .map((item, index) => (
                    <div
                      className="bg-white rounded-[20px] overflow-hidden p-[20px] shadow-md"
                      key={index}
                    >
                      <div className="relative w-full h-[300px] bg-gray-100 flex items-center justify-center">
                        <iframe
                          className="w-full h-full"
                          src={item.masked_image_url}
                          title="masked image"
                        />
                        <div
                          className="absolute inset-0 cursor-pointer"
                          onClick={() => {
                            setViewData(item);
                            setIsModalActive(true);
                          }}
                        />
                      </div>
                      <div className="mt-[20px] flex justify-between items-center gap-[20px]">
                        <p className="p-0 m-0 fs-16 fc-202224 family_outfit_semiBold_600 lh-176 capitalize">
                          {item?.main_metric?.name}
                        </p>
                        {item?.main_metric?.widget_type === 'bad_good_line' && (
                          <p
                            className={`p-0 m-0 fs-16 fc-202224 family_outfit_semiBold_600 lh-176 capitalize ${
                              item?.main_metric?.value >= 0 &&
                              item?.main_metric?.value < 49
                                ? 'text-[red]'
                                : item?.main_metric?.value >= 50 &&
                                    item?.main_metric?.value < 69
                                  ? 'text-[orange]'
                                  : item?.main_metric?.value >= 70 &&
                                      item?.main_metric?.value <= 89
                                    ? 'text-[green]'
                                    : 'text-[blue]'
                            }`}
                          >
                            {item?.main_metric?.value >= 0 &&
                            item?.main_metric?.value < 49
                              ? 'Bad'
                              : item?.main_metric?.value >= 50 &&
                                  item?.main_metric?.value < 69
                                ? 'Average'
                                : item?.main_metric?.value >= 70 &&
                                    item?.main_metric?.value <= 89
                                  ? 'Good'
                                  : 'Excellent'}
                          </p>
                        )}
                      </div>
                      <div className="mt-[10px]">
                        <p className="p-0 m-0 fs-16 fc-202224 family_outfit_semiBold_600 lh-176 capitalize">
                          {`${item?.main_metric?.value}${item?.main_metric?.widget_type === 'percentage' ? '%' : ''}`}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <div className="flex justify-center pt-120">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                  Nothing here yet
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>
      <CommonModal
        padding={'24px'}
        width={'700px'}
        modalActive={isModalActive}
        innerContent={
          <div>
            <div className="flex items-center justify-end">
              <IconButton
                aria-label="close"
                onClick={() => setIsModalActive(false)}
              >
                <CloseIcon />
              </IconButton>
            </div>

            <div className="relative w-full h-[700px] mt-[20px]">
              <iframe
                className="w-full h-full"
                src={viewData.masked_image_url}
                title="masked image"
              />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default ScanResult;
